import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img01.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#1d8633" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Partner Up with TekRevol’s Software Developers in Chicago to
              Digitize Your Business{" "}
            </h2>
            <p>
              TekRevol specializes in providing custom software development in
              Chicago for startups and enterprises. Our skilled Chicago software
              developers develop high-quality software solutions customized to
              businesses of different sizes and natures, allowing them to scale
              and grow feasibly.
            </p>
            <p>
              As a technology partner, we improve our clients' technical skills
              with proactive bug fixing and custom technology solutions.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#1d8633",
                border: "1px solid #1d8633",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
